import typeCheck from 'common/util/typeCheck';

import {
  SR_API_ACTION_APARTMENT_GET_BY_BUILDING_ID,
} from 'api/actionTypes';

export default async function getByApartmentBuildingId(
  { state, apiClient },
  { apartmentBuildingId, forceRefresh },
) {
  typeCheck('apartmentBuildingId::Number', apartmentBuildingId);

  const apartmentStatePath = ['apartments', 'byBuildingId', apartmentBuildingId];
  if (state.get(apartmentStatePath) && !forceRefresh) {
    return state.get(apartmentStatePath);
  }

  await apiClient.postWithState({
    action: SR_API_ACTION_APARTMENT_GET_BY_BUILDING_ID,
    state: state,
    payload: {
      apartmentBuildingId: apartmentBuildingId,
    },
    onSuccess(apartment) {
      if (apartment) {
        state.set(apartmentStatePath, apartment);
        state.set(['apartments', 'byId', apartment.id], apartment);
      }
    },
  });
}
